import { Auth } from '@entities/user'
import { createApi } from '@reduxjs/toolkit/query/react'
import { backendBaseQuery } from '@shared/api'
import { User } from '../model/types'
import { MessageType } from '@widgets/message-type-buttons-group/types'

// Define a service using a base URL and expected endpoints
export const userApi = createApi({
  reducerPath: 'user-api',
  baseQuery: backendBaseQuery,
  tagTypes: ['User'],
  endpoints: (build) => ({
    getMe: build.query<User, void>({
      query: () => ({
        url: `users/me`, 
        method: 'GET',
      }),
      providesTags: [
        {type: 'User', id: 'ME'}
      ],
      keepUnusedDataFor: 60,
      transformResponse: (response: User, meta, arg) => response,
    }),
    getSenderNames: build.query({
      query: (messageType: MessageType) => ({
        url: `users/sender-names/${messageType}`
      })
    }),
    getAllSenderNames: build.query<void, any>({
      query: () => ({
        url: `users/sender-names`
      })
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetMeQuery, useGetSenderNamesQuery, useGetAllSenderNamesQuery } = userApi